export const authConfig = {
  domain: process.env.AUTH0_DOMAIN || "",
  clientId: process.env.AUTH0_CLIENT_ID || "",
  audience: process.env.AUTH0_AUDIENCE || "",
  appUrl: process.env.APP_URL || "https://localhost:3000",
};
